import React from 'react';
import * as styles from './AiAskAnswer.module.scss';
import type { AiAskStreamResult } from './SearchView';
import Button from '../components/Button';
import Card, { CardSeparator } from '../components/Card';
import CardHeader from '../components/CardHeader';
import SVGIcon from '../components/SVGIcon';
import useParsedMarkdown from '../components/useParsedMarkdown';
import { PostType } from '../graphql/generated/graphql';
import aiIcon from '../icons/non-prefilled/16x16/ai.svg';
import BetaBadge from '../organization/BetaBadge';
import { getStateIcon } from '../post/PostIcon';
import postPath from '../utils/url/postPath';

interface AiAskAnswerProps {
  query: string;
  ask: AiAskStreamResult | null;
}

const AiAskAnswer = ({ query, ask }: AiAskAnswerProps) => {
  const parsedMarkdown = useParsedMarkdown(ask?.answer);
  const sources = ask?.sources ?? [];

  return (
    <Card>
      <CardHeader
        icon={<SVGIcon className={styles.icon}>{aiIcon}</SVGIcon>}
        title={
          <>
            AI Ask <BetaBadge />
          </>
        }
        meta={`Question: "${query}"`}
      />
      <CardSeparator />
      {ask && parsedMarkdown ? (
        <>
          <div
            className={styles.response}
            dangerouslySetInnerHTML={{ __html: parsedMarkdown }}
          />
          {sources.length > 0 && (
            <div className={styles.sources}>
              <div className={styles.sourcesTitle}>Sources</div>
              {sources.map((source) => (
                <div key={source.id} className={styles.source}>
                  <Button
                    variant="link"
                    icon={
                      <SVGIcon>
                        {getStateIcon({
                          type: PostType.Post,
                          draft: false,
                          archived: false,
                        })}
                      </SVGIcon>
                    }
                    to={postPath({ id: source.id, title: source.primary })}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {source.primary}
                  </Button>
                  {!!source.snippet && <> — {source.snippet}</>}
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div>
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      )}
    </Card>
  );
};

export default AiAskAnswer;
